import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { retrieveToken } from '../../../hooks/use-token';

const CourseDetailsArea = ({ course, courses, planos, activePayment }) => {
  
  const [isOpen, setOpen] = useState(false);
  const [isLogged, setIsLogged] = useState(null);

  useEffect(() => {

    const tokenApi = retrieveToken();

    if (tokenApi)
      setIsLogged(true);
    else  
      setIsLogged(false);

  });
  
  function renderParcelas(plano) {

    const formattedValue = (monetaryValue) => new Intl.NumberFormat('pt-BR', {
      style: 'currency',
      currency: 'BRL',
      minimumFractionDigits: 2,
    }).format(monetaryValue);
    
    return <>
    <div className="course__video-price">
    <h5> {plano.parcelas}x de {formattedValue(plano.valor_parcela)}<span></span> </h5>
    {course.oldPrice && <h5 className="old-price">${formattedValue(course.oldPrice)}</h5>}
    </div>
    {plano.porcentagem != "" && plano.porcentagem != null && <div className="course__video-discount">
    <span>{plano.porcentagem}% OFF</span>
    </div>}
    </>;
    
  }
  
  function renderHtml(html) {
    return {__html: html};
  }

  function showHtml(html) {
    return <div dangerouslySetInnerHTML={renderHtml(html)} />;
  }

  function renderListaPlanos() {
    
    const listaPlanosHtml = [];
    
    planos.forEach((plano) => {
    
      if (plano.flag_ativo == '1' && plano.flag_esgotado != '1') {
        
        listaPlanosHtml.push(
          <div className="course__sidebar-widget-2 white-bg mb-20">
          <div className="course__video">
          {/* <div className="course__video-thumb w-img mb-25">
          <img src="/assets/img/curso/video/course-video.jpg" alt="" />
          <div className="course__video-play">
          <button onClick={()=> setOpen(true)} className="play-btn"> 
          <i className="fas fa-play"></i> </button>
          </div>
        </div> */}
        <div className="course__video-meta mb-25 d-flex align-items-center justify-content-between">
        {renderParcelas(plano)}
        </div>
        
        <div className="course__payment mb-35">
        <h3>{plano.titulo}</h3>  
        </div>
        <div className="course__payment mb-35">
        { showHtml(plano.descricao) }
        </div>
        <div className="course__enroll-btn">
          {<Link to={`/assinar-agora/${plano.cd_plano}`}>
          <button className="e-btn e-btn-7 w-100">
            ASSINAR AGORA
            <i className="far fa-arrow-right"></i>
          </button>
          </Link>}
          {/* {!isLogged && <Link to={`/inscrever-se`}>
          <button className="e-btn e-btn-7 w-100">
            CRIE A SUA CONTA
            <i className="far fa-arrow-right"></i>
          </button>
          </Link>} */}
        </div>
        </div>
        </div>
        )
        
      }
      
    })
    
    return (listaPlanosHtml);
    
  }
  
  return (
    <>
    {/* video modal start */}
    {/* <ModalVideo channel='youtube' autoplay isOpen={isOpen} 
  videoId={course.y_video_id} onClose={() => setOpen(false)} /> */}
  {/* video modal end */}
  
  <section className="page__title-area pt-120 pb-90">
  {/* <div className="page__title-shape">
  <img className="page-title-shape-5 d-none d-sm-block" 
  src="/assets/img/page-title/page-title-shape-1.png" alt="" />
  <img className="page-title-shape-6" src="/assets/img/page-title/page-title-shape-6.png" alt="" />
  <img className="page-title-shape-7" src="/assets/img/page-title/page-title-shape-4.png" alt="" />
  </div> */}
  <div className="container">
  <div className="row">
  <div className="col-xxl-8 col-xl-8 col-lg-8">
  <div className="course__wrapper">
  <div className="page__title-content mb-25">
  <div className="page__title-breadcrumb">
  <nav aria-label="breadcrumb">
  <ol className="breadcrumb">
  <li className="breadcrumb-item"><Link to="/">Home</Link></li>
  <li className="breadcrumb-item"><Link to="/cursos">Cursos</Link></li>
  <li className="breadcrumb-item active" aria-current="page">{course.nome}</li>
  </ol>
  </nav>
  </div>
  {/* <span className="page__title-pre">{course.category}</span> */}
  <h5 className="page__title-3">{course.nome}</h5>
  </div>
  <div className="course__img w-img mb-30">
    {course.file_venda != "" && <img src={`https://v1.profaprizattera.com.br/uploads/curso/${course.file_venda}`} />}
  </div>
  <div className="course__tab-2 mb-45">
  <ul className="nav nav-tabs" id="courseTab" role="tablist">
  <li className="nav-item" role="presentation">
  <i className="icon_ribbon_alt"></i> <span>Conheça o Curso</span> 
  </li>
  {/* <li className="nav-item" role="presentation">
  <button className="nav-link " id="curriculum-tab" data-bs-toggle="tab" data-bs-target="#curriculum" type="button" role="tab" aria-controls="curriculum" aria-selected="false"> <i className="icon_book_alt"></i> <span>Curriculum</span> </button>
  </li>
  <li className="nav-item" role="presentation">
  <button className="nav-link" id="review-tab" data-bs-toggle="tab" data-bs-target="#review" type="button" role="tab" aria-controls="review" aria-selected="false"> <i className="icon_star_alt"></i> <span>Reviews</span> </button>
  </li>
  <li className="nav-item" role="presentation">
  <button className="nav-link" id="member-tab" data-bs-toggle="tab" data-bs-target="#member" type="button" role="tab" aria-controls="member" aria-selected="false"> <i className="fal fa-user"></i> <span>Members</span> </button>
</li> */}
</ul>
</div>
<div className="course__tab-content mb-95">
<div className="tab-content" id="courseTabContent">
<div className="tab-pane fade show active" id="description" role="tabpanel" aria-labelledby="description-tab">
<div className="course__description">
<p>{ showHtml(course.descricao) }</p>
</div>
<div className="course__description">
  <a className='btn btn-success btn-lg btn-large btn-whatsapp' style={{backgroundColor: '#25D366', borderColor: '#25D366'}} target='_blank' rel='noreferrer' href={`https://wa.me/554699731162`}>Fale com a Profa. Zattera no WhatsApp</a>
</div>
</div>
<div className="tab-pane fade" id="curriculum" role="tabpanel" aria-labelledby="curriculum-tab">

</div>
<div className="tab-pane fade" id="review" role="tabpanel" aria-labelledby="review-tab">

</div>
<div className="tab-pane fade" id="member" role="tabpanel" aria-labelledby="member-tab">

</div>
{/* <div className="course__share">
<h3>Compartilhe:</h3>
<ul>
<li><a href="#" className="fb" ><i className="social_facebook"></i></a></li>
<li><a href="#" className="tw" ><i className="social_twitter"></i></a></li>
<li><a href="#" className="pin" ><i className="social_pinterest"></i></a></li>
</ul>
</div> */}
</div>
</div>
{/* <div className="course__related">
<div className="row">
<div className="col-xxl-12">
<div className="section__title-wrapper mb-40">
<h2 className="section__title">Related <span className="yellow-bg yellow-bg-big">Course<img src="/assets/img/shape/yellow-bg.png" alt="" /></span></h2>
<p>You don't have to struggle alone, you've got our assistance and help.</p>
</div>
</div>
</div>
<div className="row">
<div className="col-xxl-12">
<div className="course__slider swiper-container pb-60">
{<Swiper modules={[Pagination]} spaceBetween={20}
slidesPerView={1} className="pb-60" loop={true}
pagination={{ el: '.swiper-pagination', clickable: true }}
autoplay={{ delay: 6000 }}
breakpoints={{
  // when window width is >= 768px
  768: {
    slidesPerView: 2
  },
}}
>
{courses.slice(0, 4).map(item => {
  return (
    <SwiperSlide key={item.id}>
    <div className="course__item course__item-3 swiper-slide white-bg mb-30 fix">
    <div className="course__thumb w-img p-relative fix">
    <Link to={`/curso-detalhes/${item.id}`}>
    <img src={item.courseImage} alt="" />
    </Link>
    <div className="course__tag">
    <a href="#" className={item.color}>{item.category}</a>
    </div>
    </div>
    <div className="course__content">
    <div className="course__meta d-flex align-items-center justify-content-between">
    <div className="course__lesson">
    <span><i className="far fa-book-alt"></i>{item.lesson} Lesson</span>
    </div>
    <div className="course__rating">
    <span><i className="icon_star"></i>{item.rating} ({item.total_rating})</span>
    </div>
    </div>
    <h3 className="course__title">
    <Link to={`/curso-detalhes/${item.id}`}>{item.title}</Link>
    </h3>
    <div className="course__teacher d-flex align-items-center">
    <div className="course__teacher-thumb mr-15">
    <img src={item.teacherImg} alt="" />
    </div>
    <h6><Link to="/instructor-details">{item.teacherName}</Link></h6>
    </div>
    </div>
    <div className="course__more d-flex justify-content-between align-items-center">
    {item.price === 'free' && <div className="course__status">
    <span>Free</span>
    </div>}
    {item.price !== 'free' && <div className="course__status d-flex align-items-center">
    <span className={item.color}>${item.price}</span>
    {item.oldPrice && <span className="old-price">${item.oldPrice}</span>}
    </div>}
    <div className="course__btn">
    <Link to={`/curso-detalhes/${item.id}`} className="link-btn">
    Know Details
    <i className="far fa-arrow-right"></i>
    <i className="far fa-arrow-right"></i>
    </Link>
    </div>
    </div>
    </div>
    </SwiperSlide>
    )
  })
}

<div className="swiper-pagination"></div>
</Swiper>}
</div>
</div>
</div>
</div> */}
</div>
</div>
<div className="col-xxl-4 col-xl-4 col-lg-4">
<div className="course__sidebar pl-70 p-relative">
<div className="course__shape">
<img className="course-dot" src="/assets/img/curso/course-dot.png" alt="" />
</div>
{activePayment && (
  <div className="sidebar__widget-head mb-35">
  <h3 className="sidebar__widget-title">Curso ativo</h3>
  <p>Você já possui uma assinatura ativa este curso, clique abaixo para acessar o conteúdo.</p>
     <Link to={`/curso/${course.cd_curso}/modulos`}>
          <button className="e-btn e-btn-7 w-100">
            ACESSAR CONTEÚDO
          </button>
      </Link>
  </div>
)}
<div className="sidebar__widget-head mb-35">
<h3 className="sidebar__widget-title">Planos disponíveis</h3>
</div>
{renderListaPlanos()}
{/* <div className="course__sidebar-widget-2 white-bg mb-20">

<RelatedCourse />

</div> */}
</div>
</div>
</div>
</div>
</section>
</>
);
};

export default CourseDetailsArea;